//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EsQuery from "@/javascript/esQuery";
import tabWrap from "@/components/lyx-components/tab-wrap/index.vue";
import goSearch from "@/components/lyx-components/search-box/index.vue";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import menus from "@/components/lyx-components/menus/index";
import util from "@/javascript/util";
import { formatDate } from "@/javascript/formatDate";
import { log } from "util";
import bus from "@/javascript/bus";
import goBack from '@/components/public-components/goBack/index.vue'

export default {
  components: {
    menus,
    tabWrap,
    goSearch,
    goBack
  },
  data() {
    return {
      menuSlide: false,
      isWeixin: util.isWeiXin(),
      cityCode: this.$route.params.cityCode,
      tabsSticky: false,
      infiniteStatus: false,
      infiniteAll: false,
      slideUp: false,
      coverShow: false,
      videoShow: false,
      videoUrl: "",
      newListData: [],
      localPosition: {},
      scenicList: [],
      img_video_idx: 0,
      video_img:'',
      video_tit:'',
      menuData: [],
      videoList: [],
      guideList: [],
      cityData: [],
      strategyList: [],
      tabsList: [],
      hotelList: [],
      foodData: [],
      goodPlace: [],
      glDesData: "",
      curTab: 0,
      cityId: "",
      tabs: ["热门", "吃什么", "买什么", "住哪里"],
      tabActive: 0,
      foodName: "",
      foodId: "",
      foodList: [],
      defautActive: 0,
      tabsListPageNo: 0,
      tabsListPageSize: 10,
      bannerData: [],
      cityName: {},
      userInfo: bus.userInfo.user ? bus.userInfo.user : {},
      isLogin: Boolean(bus.userInfo.access_token),
      foodMenu: [],
      begfoodData: [],
      foodListPageNo: 0,
      foodListPageSize: 5,
      areaCode: "630202",
      indexVideo: [],
      showState: false,
      videoUrl: "",
      classify: "",
      villageList: [],
      villageBefore: [],
      imgList: [],
      gallery: [],
      showPic: true,
      showVideo: false,
      onePlay: "",
      galleryshow: false,
      indexLength: 0,
      flagVideo: "",
      navImg: {
        navlyzx: "navlyzx.svg",
        oneMoer: "oneMoer.svg",
      },

    };
  },
  filters: {
    // 格式化时间戳
    formatDate(datestamp) {
      if (datestamp != null) {
        let result = new Date(Number(datestamp));
        const y = result.getFullYear();
        let m = result.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        let d = result.getDate();
        d = d < 10 ? "0" + d : d;
        let h = result.getHours();
        h = h < 10 ? "0" + h : h;
        let n = result.getMinutes();
        n = n < 10 ? "0" + n : n;
        let s = result.getSeconds();
        s = s < 10 ? "0" + s : s;
        return `${y}-${m}-${d}`;
      }
    },
  },
  mounted() {
    document.title = '乡村游';

    /**
     * 页面滚动
     */
    window.addEventListener("scroll", this.windowScroll);
    this.getTabsList();
    this.getSwiper();
    this.getCommentList();
    this.getVideo();
    this.njlabelListL();

  },
  methods: {
    windowScroll: function () {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 精选、景区、门票等tab栏滚动固定
      if (!this.$refs.stickyBox) {
        return;
      }
      if (
        scrollTop >=
        this.$refs.stickyBox.offsetTop
      ) {
        this.tabsSticky = true;
      } else {
        this.tabsSticky = false;
      }
      // 底部加载
      if (util.pullUpLoad()) {
        this.infinite();
      }
    },

    tabsClick(e) {
      this.curTab = e;
      this.tabActive = e;
      this.tabsListPageNo = 0;
      this.infiniteAll = false;
      this.infiniteStatus = true;
      this.getTabsList(true);
      this.tabsList = [];
      this.slideLeft(e);
    },
    coverCancel() {
      this.slideUp = false;
      this.coverShow = false;
    },
    slideLeft(e) {
      let list = document.getElementsByClassName("slide-li"),
        lefWidth = 0;
      lefWidth = list[e].offsetLeft / 4.5;
      this.$refs.slideTab.scrollLeft = lefWidth;
    },
    videoPlay() {
      this.$refs.video.play()
    },
    videoStop() {
      this.$refs.video.pause()
      // this.$refs.video.end()
      this.videoUrl = ''
      this.showState = false
      this.showPic = true
    },
    changevideo(index){
      this.video_img = this.videoList[index].videos[0][0].coverImageUrl
      this.video_tit = this.videoList[index].title
      this.img_video_idx = index
    },
    videostart(index) {
      this.onePlay = this.videoList[index].link != "" ? this.videoList[index].link : this.PIC_BASE_URL + this.videoList[index].videos[0][0].fileUrl
      // this.videoList[index]._source.link
      this.showPic = false
      this.showVideo = true
      const that = this
      if (this.onePlay != '') {
        // if(that.$refs.oneVideo.buffered()){
        //     setTimeout(function () {
        //      that.$refs.oneVideo.buffered()
        //     }, 200)
        // }else{
        setTimeout(function () {
          that.$refs.oneVideo.play()
        }, 200)
        // }
      }
    },
    videoStopOne() {
      this.showPic = true
      this.showVideo = false
      this.onePlay = ''
    },


    // tab切换
    getTabsList: function (status) {
      const _this = this;
      switch (this.curTab) {
        case 0:
          // 热门
          const querystring = require("querystring");
          const recommendEsQuery = new EsQuery();
          recommendEsQuery
            .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)
          .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
          .addString(
              "category",
              this.XXCJ_TYPE_CODE.CY,
              recommendEsQuery.and,
              false
            )
          .addString("tags", "热门", recommendEsQuery.and, false)
          const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
          this.$http.post('api/wtcp-kb/pub/doc/search', querystring.stringify({
            indexName: this.INDEX_NAME_TYPE.periphery,
            esJsonQuery: recommendEsJsonQuery
          }))
            .then((response) => {
             const msList = response.data.data;
              this.tabsList = this.tabsList.concat(msList);
              if (response.data.data.length < this.tabsListPageSize) {
                this.infiniteAll = true;
              }
              this.infiniteStatus = false;
              
            })
            .then((response) => {
               const querystring8 = require('querystring');
          const houseEsQuery = new EsQuery()
          houseEsQuery
            .addStartWith("category", _this.XXCJ_TYPE_CODE.JDMS, houseEsQuery.and, false)
            .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, houseEsQuery.and, false)
            .addString("tags", "热门", houseEsQuery.and, false)
            .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
          const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray())
          _this.$http.post('/api/wtcp-kb/pub/doc/search', querystring8.stringify({
            indexName: _this.INDEX_NAME_TYPE.hotelList,
            esJsonQuery: houseEsJsonQuery
          }))
            .then((response2) => {
              const quanjingList = response2.data.data;
              this.tabsList = this.tabsList.concat(quanjingList);
              if (response2.data.data.length < this.tabsListPageSize) {
                this.infiniteAll = true;
              }
              this.infiniteStatus = false;

             
            })
              
            }).then((response) => {
              const querystring9 = require('querystring');
          const travelsEsQuery = new EsQuery()
          travelsEsQuery
          
            .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
            .addString("tags", "热门", travelsEsQuery.and, false)

          const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray())
          this.$http.post('/api/wtcp-kb/pub/doc/search', querystring9.stringify({
            'indexName': this.INDEX_NAME_TYPE.produce,
            'esJsonQuery': travelsEsJsonQuery
          }))
            .then((response3) => {
              const commentList = response3.data.data;
            
              this.tabsList = this.tabsList.concat(commentList);
              if (response3.data.data.length < this.tabsListPageSize) {
                this.infiniteAll = true;
              }
              this.infiniteStatus = false;
            })
        
              
            })
            .then(() => {
              if (status && this.$refs.stickyBox) {
                window.scrollTo(
                  0,
                  this.$refs.stickyBox.offsetTop
                );
              }
            });
          break;
        case 1:
          // 美食
          const querystring3 = require('querystring');
          const strategyEsQuery3 = new EsQuery()
          strategyEsQuery3
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, strategyEsQuery3.and, false)
          .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
          .addString(
              "category",
              this.XXCJ_TYPE_CODE.CY,
              strategyEsQuery3.and,
              false
            )
          // .addString("tags", "热门", strategyEsQuery3.and, false)
          const strategyEsJsonQuery3 = JSON.stringify(strategyEsQuery3.getArray())
          this.$http.post('api/wtcp-kb/pub/doc/search', querystring3.stringify({
            indexName: this.INDEX_NAME_TYPE.periphery,
            esJsonQuery: strategyEsJsonQuery3
          }))
            .then((response) => {
              const strategyList = response.data.data;
            
              const strategyList2 = strategyList.map((scenic) => {
                return scenic._source;
              });
              this.tabsList = this.tabsList.concat(strategyList2);
              if (response.data.data.length < this.tabsListPageSize) {
                this.infiniteAll = true;
              }
              this.infiniteStatus = false;
            })
            .then(() => {
              if (status && this.$refs.stickyBox) {
                window.scrollTo(
                  0,
                  this.$refs.stickyBox.offsetTop
                );
              }
            });
          break;
        case 2:
          // 商品
          const querystring2 = require('querystring');
          const travelsEsQuery = new EsQuery()
          travelsEsQuery
          
            .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
          const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray())
          this.$http.post('/api/wtcp-kb/pub/doc/search', querystring2.stringify({
            'indexName': this.INDEX_NAME_TYPE.produce,
            'esJsonQuery': travelsEsJsonQuery
          }))
            .then((response) => {
              const commentList = response.data.data;
            
              this.tabsList = this.tabsList.concat(commentList);
              if (response.data.data.length < this.tabsListPageSize) {
                this.infiniteAll = true;
              }
              this.infiniteStatus = false;
            })
            .then(() => {
              if (status && this.$refs.stickyBox) {
                window.scrollTo(
                  0,
                  this.$refs.stickyBox.offsetTop
                );
              }
            });
          break;
    
        case 3:
          //酒店
          const querystring6 = require('querystring');
          const houseEsQuery = new EsQuery()
          houseEsQuery
            .addStartWith("category", _this.XXCJ_TYPE_CODE.JDMS, houseEsQuery.and, false)
            .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, houseEsQuery.and, false)
            // .addString("tags", "热门", houseEsQuery.and, false)
            .addPage(this.tabsListPageNo * this.tabsListPageSize, this.tabsListPageSize)
          const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray())
          _this.$http.post('/api/wtcp-kb/pub/doc/search', querystring6.stringify({
            indexName: _this.INDEX_NAME_TYPE.hotelList,
            esJsonQuery: houseEsJsonQuery
          }))
            .then((response) => {
              const quanjingList = response.data.data;

              this.tabsList = this.tabsList.concat(quanjingList);
              if (response.data.data.length < this.tabsListPageSize) {
                this.infiniteAll = true;
              }
              this.infiniteStatus = false;
            })
            .then(() => {
              if (status && this.$refs.stickyBox) {
                window.scrollTo(
                  0,
                  this.$refs.stickyBox.offsetTop
                );
              }
            });
          break;
      }
    },
    infinite: function () {
      if (this.infiniteAll) {
        return;
      }
      if (this.infiniteStatus) {
        return;
      }
      this.infiniteStatus = true;
      this.tabsListPageNo += 1;
      this.getTabsList();
    },
    closeSlide() {
      this.slideUp = false;
      this.coverShow = false;
    },
    slideItem(e) {
      this.curTab = e;
      this.tabActive = e;
      this.tabsListPageNo = 0;
      this.infiniteAll = false;
      this.infiniteStatus = true;
      this.getTabsList(true);
      this.tabsList = [];
      this.slideLeft(e);
      this.slideUp = false;
      this.coverShow = false;
    },


    getVideo() {
      const _this = this
      const newsEsQuery = new EsQuery();
      const querystring7 = require("querystring");
      newsEsQuery
        .addStartWith(
          "deptCode",
          this.DEPT_CODE.DEPTCODE,
          newsEsQuery.and,
          false
        )
        .addString("publishStatus", 1, newsEsQuery.asc, false)
        .addSort("createdDate", newsEsQuery.desc, false);

      newsEsQuery.addPage(0, 10);
      newsEsQuery
        .addStartWith(
          "catalogCode",
          "00000000,1657795555718",
          newsEsQuery.and,
          false
        )
      const newsJsList3 = JSON.stringify(newsEsQuery.getArray());

      this.$http
        .post(
          "/api/wtcp-kb/pub/doc/search",
          querystring7.stringify({
            indexName: this.INDEX_NAME_TYPE.newsList,
            esJsonQuery: newsJsList3,
          })
        )
        .then((res) => {
          let videoList = res.data.data
          _this.video_img = videoList[0]._source.videos[0][0].coverImageUrl
          _this.video_tit = videoList[0]._source.title
          _this.videoList = videoList.map(item => item._source)
          _this.$nextTick(() => {
            new Swiper('.big-video', {
              slidesPerView: '3.5',
              spaceBetween: 18,
              // loop: true,
              freeMode: true,
              direction: 'vertical',
              observer: true,
              observeParents: true
            });
          })

        })
    },
    // 最美乡村
    getCommentList() {

      const _this = this
      const querystring5 = require('querystring')
      const recommendEsQuery = new EsQuery()
      recommendEsQuery.addString("category", this.XXCJ_TYPE_CODE.LYSFC, recommendEsQuery.and, false)
          .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)
          .addPage(this.pageNo * this.pageSize, this.pageSize)
          .addSort("weight", recommendEsQuery.desc, false)
      const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
      this.$http.post('/api/wtcp-kb/pub/doc/search', querystring5.stringify({
          'indexName': this.INDEX_NAME_TYPE.scenic,
          'esJsonQuery': recommendEsJsonQuery
      }))
     .then(function (res) {
        const data = res.data.data
        let hotelList = data.filter(item => item._source.score != '0.00')
        _this.hotelList = hotelList.map(item => item._source)
        _this.$nextTick(() => {
          new Swiper('.the-recommend-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            initialSlide: 0,
          })
        })
        // _this.hotelList = _this.hotelList.slice(3,6)
      })
    },
    njlabelListL() {
      const _this = this

      const agritainmentEsQuery = new EsQuery()
      const querystring = require('querystring');
      agritainmentEsQuery
        .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, agritainmentEsQuery.and, false)
        .addStartWith("region", _this.AREA_CODE.AREACODE, agritainmentEsQuery.and, false)
        .addSort("weight", agritainmentEsQuery.desc, false)
        .addPage(0, 10)
      const agritainmentEsJsonQuery = JSON.stringify(agritainmentEsQuery.getArray())
      _this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
        indexName: _this.INDEX_NAME_TYPE.rural,
        esJsonQuery: agritainmentEsJsonQuery
      })).then((res) => {
        let guideList = res.data.data
        this.guideList = guideList
        _this.$nextTick(() => {
          new Swiper('.the-njl-swiper', {
            slidesPerView: 'auto',
            // spaceBetween: 20,
            initialSlide: 0,
            observer: true,
              observeParents: true,
          })
        })
      })

    },
    getSwiper() {
      // new Swiper(".other-swiper", {
      //   slidesPerView: "auto",
      //   // spaceBetween: 10,
      //   // slidesPerColumn:3,
      //   freeMode: false,
      // });
    },
  },
};
